export default __webpack_public_path__ + "static/media/xxivk_lg_bk3.e9bd2f38.svg";